import { memo, useContext } from "react"

import { useLanguage } from "@languages/index"
import TextInputField from "components/textInput"
import CampaignFormField from "../../../../campaignFormFieldGroup/components/campaignFormField/campaignFormField"
import { CampaignFormFieldWrapperProps } from "../formFields.types"
import { CampaignFormContext } from "pages/campaigns/campaignForm/campaignForm.context"

const DeliveryCompanyField = ({ elementIndex }: CampaignFormFieldWrapperProps) => {
  const language = useLanguage()
  const languageTexts = { ...language.pages.campaigns }
  const {
    campaignFormMethods: { register },
  } = useContext(CampaignFormContext)

  return (
    <CampaignFormField label={`${elementIndex}. ${languageTexts.campaign_form_delivery_company_field_label}`}>
      <TextInputField register={register("deliveryCompanyName", { required: true })} bordered />
    </CampaignFormField>
  )
}

export default memo(DeliveryCompanyField)
